import { useQuery } from "@tanstack/react-query";
import {
  VideoSearchParams,
  videoSearch,
} from "common/api/sakusas/sakusas_video";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasVideoSearch = (searchParams?: VideoSearchParams) => {
  const { data: video } = useQuery(
    [QUERY_KEYS.SAKUSAS_VIDEO_SEARCH, searchParams],
    async () => {
      const result = await videoSearch(searchParams);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof video !== "undefined" && video !== "" ? video : null;
  return result;
};
